import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { roundToDecimalPlace } from 'utils/helpers';
import AgGrid from 'screens/components/advanced/AgGrid';

const DataGrid = ({ agGridRef }) => {
    // Redux State
    const { hourlySalesSecondary, hourlySalesSecondaryTotal: currentTotal } = useSelector(state => state.reports || {});
    const [total, setTotal] = useState([]);

    useEffect(() => {
        const totaldata = [{
            time: `Total`,
            qty: currentTotal ? currentTotal.qty : "",
            grossSales: currentTotal ? currentTotal.grossSales : "",
            cost: currentTotal ? currentTotal.cost : "",
            profit: currentTotal ? currentTotal.profit : "",
            gpm: currentTotal ? currentTotal.gpm : ""
        }];
        setTotal(totaldata);
    }, [hourlySalesSecondary, currentTotal])

    const timeCell = ({ value }) => <span>{typeof value === "number" ? `${value}:00 - ${(value + 1)}:00` : value}</span>;
    const decimalCell = ({ value }) => <span>{value ? value.toFixed(2) : 0.00}</span>;
    const dollarCell = ({ value }) => <span>{value ? `$${value.toFixed(2)}` : 0.00}</span>;
    const percentageCell = ({ value }) => <span>{value ? roundToDecimalPlace(value, 2) : `0`}%</span>;

    const columns =  [
        { headerName: "Hour", field: "time", filter: "agTextColumnFilter", sortable: true, width: 120, cellRenderer: timeCell },
        { headerName: "NetQuan", field: "qty", filter: "agNumberColumnFilter", sortable: true, width: 200, cellRenderer: decimalCell },
        { headerName: "NetSale", field: "grossSales", filter: "agNumberColumnFilter", sortable: true, width: 100, cellRenderer: dollarCell },
        { headerName: "Cost", field: "cost", filter: "agNumberColumnFilter", sortable: true, width: 150, cellRenderer: dollarCell },
        { headerName: "Profit", field: "profit", filter: "agNumberColumnFilter", sortable: true, width: 150, cellRenderer: dollarCell },
        { headerName: "GP", field: "gpm", filter: "agNumberColumnFilter", sortable: true, width: 150, cellRenderer: percentageCell }
    ];
    
    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
    };

    return (<AgGrid agGridRef={agGridRef} showFilter={true} rows={hourlySalesSecondary} columns={columns} defaultColDef={defaultColDef} total={total} />)
}

export default DataGrid;